import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import {Col, Row, Title, Typography} from "@bezlimit/bezlimit-ui";
//component
import {ProfileInfo} from "./profileInfo";
import {ConfirmEmail} from "./confirmEmail";
import {ConfirmPhone} from "./confirmPhone";
import {RejectPassport} from "./rejectPassport";
import {RegisterPassport} from "./registerPassport";
import PersonalManager from "../../blocks/widgets/personalManages";
// services
import UserService from "../../../services/UserService";
//store
import Store from "../../../stores";

import "./style.scss";
import SavingBankCards from "./savingBankCards";

export const Profile: React.FC = observer(() => {
    const {t} = useTranslation();

    const getUserInfo = async () => {
        await UserService.getUserLoyalty();
    };

    useEffect(() => {
        getUserInfo();
    }, []);

    return (
        <Typography as="div" className="bl-profile-page">
            <Title title={t("Профиль")} />
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <ProfileInfo />
                </Col>
                <Col span={24}>
                    <SavingBankCards />
                </Col>
                {Store.user.personal_data?.passport_status === "reject" && (
                    <Col span={24}>
                        <RejectPassport />
                    </Col>
                )}
                {Store.user.personal_data?.phone_status !== "confirmed" && (
                    <Col xs={24} md={12} className="bl-profile-confirm">
                        <ConfirmPhone />
                    </Col>
                )}
                {Store.user.profile?.email_status !== "confirmed" && (
                    <Col xs={24} md={12} className="bl-profile-confirm">
                        <ConfirmEmail />
                    </Col>
                )}
                {Store.user.personal_data?.passport_status !== "confirmed" && (
                    <Col span={24}>
                        <RegisterPassport />
                    </Col>
                )}
                <Col span={24}>
                    <PersonalManager title="Вас пригласил" isProfile={true} />
                </Col>
            </Row>
        </Typography>
    );
});
